import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { useNavigate } from 'react-router-dom'; 
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const statistiquesEnvironnementalesData = [
  {
    title: "Stratégie Nationale de Développement des Statistiques de l’Environnement de 2018-2022 (SNDSE 2018-2022)",
    principalLink: "/documents/Annuaires/Stratégie-nationale-de-développement-des-statistiques-de-lenvironnement-SNDSE-2018-2022.pdf",
    image: 'assets/annuaires/annuairesEnv.png',
    description: "La Stratégie Nationale pour le Développement des Statistiques Environnementales (SNDSE 2018-2022) vise à renforcer la production de données fiables avec un budget de 25,5 milliards FBu, dont 76% provenant de partenaires internationaux, pour mieux répondre aux besoins des ODD et des politiques nationales.",
    date: "2017-10-30",
    publicationDate: "2024-01-15",
  },
  {
    title: "ANNUAIRE DES STATISTIQUES DE L’ENVIRONNEMENT, EDITION 2016",
    principalLink: "/documents/Annuaires/Annuaire-des-statistique-de-lenvironnement-2016.pdf",
    image: 'assets/annuaires/annuairesEnv.png',
    description: "L'annuaire des statistiques environnementales 2016 du Burundi révèle que 138 980 cas de diarrhée avec déshydratation et 110 669 cas de paludisme grave confirmé ont été enregistrés, mettant en lumière les défis sanitaires liés à l'environnement.",
    date: "2017-09-30",
    publicationDate: "2017-09-30",
  },
  {
    title: "ANNUAIRE DES STATISTIQUES DE L’ENVIRONNEMENT, EDITION 2015",
    principalLink: "/documents/Annuaires/Annuaire-des-statistiques-environnementales-2015.pdf",
    image: 'assets/annuaires/annuairesEnv.png',
    description: "L'annuaire statistique environnemental 2015 du Burundi révèle que 5 150 319 cas de paludisme grave confirmé, 151 179 cas de diarrhée avec déshydratation et 730 hectares ravagés par des feux de brousse à Bujumbura ont été enregistrés, mettant en évidence les défis sanitaires et écologiques du pays.",
    date: "2015-09-30",
    publicationDate: "2015-09-30",
  },
];

function AnnuaireStatistiquesEnvironnementales() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredStatistiques, setFilteredStatistiques] = useState(statistiquesEnvironnementalesData);
  const navigate = useNavigate();

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredStatistiques(statistiquesEnvironnementalesData);
    } else {
      const filtered = statistiquesEnvironnementalesData.filter((statistique) => {
        const statistiqueYear = new Date(statistique.date).getFullYear();
        return statistiqueYear === parseInt(year);
      });
      setFilteredStatistiques(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />

        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main }}>
            Annuaire des Statistiques Environnementales
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Les statistiques de l’environnement ont été initialement publiées dans l'annuaire des statistiques agricoles et, depuis 2015, elles sont compilées dans l'annuaire des statistiques environnementales. Les données sont organisées selon le Cadre de Développement de Statistiques de l’Environnement 2013, à travers six composantes : (i) conditions et qualité de l'environnement, (ii) ressources environnementales et leur utilisation, (iii) résidus, (iv) phénomènes extrêmes et catastrophes, (v) établissements humains, santé et protection, (vi) gestion et engagement en matière d'environnement.
          </Typography>

          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionner par l'année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionner par l'année de publication"
            >
              <MenuItem value="Tous">Toutes les statistiques</MenuItem>
              {[...new Set(statistiquesEnvironnementalesData.map((stat) => new Date(stat.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

  
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredStatistiques.slice(0, visibleCount).map((statistique, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={statistique.principalLink}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 91, height: 140, m: 2 }}
                        image={statistique.image}
                        alt={statistique.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                        <a
                        target="_blank"
                          href={statistique.principalLink}
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: theme.palette.primary.main }}
                        >
                         {<DownloadIcon />} {statistique.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {statistique.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(statistique.publicationDate).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredStatistiques.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Statistiques
            </Button>
          )}
  <br />
  <br />
          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Button
                onClick={() => navigate('/annuaire')}
              style={{
                marginTop: '5px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              <ArrowBackIcon style={{ marginRight: '8px', padding:'10px' }} />
              Retour à la page principale
            </Button>
          </Box>
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default AnnuaireStatistiquesEnvironnementales;